const isObject = (value) => Boolean(value) && typeof value === 'object';
const hasId = (value) => isObject(value) && 'id' in value;
const deriveNestedAllowedFields = (allowedFields, parentKey) => allowedFields.filter((field) => field.startsWith(`${parentKey}.`)).map((field) => field.slice(parentKey.length + 1));
const shouldIncludeField = (allowedFields, key) => allowedFields.some((field) => field === key || field.startsWith(`${key}.`));
const normalizeArrayValue = (value) => value.map((item) => (hasId(item) ? item.id : item));
const normalizeObjectValue = (key, value, allowedFields) => {
    if (key === 'model_and_make' && !hasId(value)) {
        return undefined;
    }
    if (hasId(value)) {
        return value.id;
    }
    const nestedAllowedFields = deriveNestedAllowedFields(allowedFields, key);
    return transformVehicleDetails(value, nestedAllowedFields);
};
/**
 * Transforms vehicle details from vehicle-lookup-service format to IMS format.
 *
 * 1. Strips fields not in the ad model schema (ideally this should be fixed in vehicle-lookup-service)
 * 2. Normalizes managed fields from {id, text} objects to just the id value
 */
export const transformVehicleDetails = (details, allowedFields) => {
    return Object.entries(details).reduce((acc, [key, value]) => {
        if (!shouldIncludeField(allowedFields, key)) {
            return acc;
        }
        if (!isObject(value)) {
            acc[key] = value;
            return acc;
        }
        if (Array.isArray(value)) {
            acc[key] = normalizeArrayValue(value);
            return acc;
        }
        const normalized = normalizeObjectValue(key, value, allowedFields);
        if (normalized !== undefined) {
            acc[key] = normalized;
        }
        return acc;
    }, {});
};
/**
 * Extracts all field names (dot-notation paths) from ad model schema field definitions.
 *
 * @param fields - Field definitions array from IMS /model/{model} response
 * @returns Array of dot-notation field names defined in the schema
 *
 * @example
 * extractFieldNamesFromSchema([{ name: 'engine', children: [{ name: 'effect' }] }])
 * // Returns: ['engine', 'engine.effect']
 */
export const extractFieldNamesFromSchema = (fields, parentName = '') => {
    return fields.flatMap((field) => {
        const fieldName = parentName ? `${parentName}.${field.name}` : field.name;
        if ('children' in field) {
            return [fieldName, ...extractFieldNamesFromSchema(field.children, fieldName)];
        }
        return fieldName;
    });
};
